import { MAX_FILES_PER_UPLOAD } from 'src/common/constants/uploadLimits';

type UploadBatchValidation =
  | { valid: true }
  | { valid: false; count: number; max: number };

export function validateUploadBatchSize(
  fileCount: number,
  maxCount: number = MAX_FILES_PER_UPLOAD,
): UploadBatchValidation {
  if (fileCount <= maxCount) {
    return { valid: true };
  }

  return { valid: false, count: fileCount, max: maxCount };
}
